<template>
    <div class="container">
        <HeroSection />

        <CatalogTeaser />

        <AreasSection />

        <section id="home-process" class="section process">
            <h2 class="process-title">Cómo trabajamos</h2>
            <p class="process-intro">
                Un proceso corto y sin vueltas: nos cuentas qué necesitas, te
                proponemos cómo resolverlo y lo entregamos funcionando.
            </p>

            <ol class="process-steps">
                <li v-for="(step, index) in steps" :key="step.title" class="process-step">
                    <img :src="step.icon" :alt="step.iconAlt" loading="lazy">
                    <span class="process-number">Paso {{ index + 1 }}</span>
                    <h3 class="process-step-title">{{ step.title }}</h3>
                    <p class="process-step-text">{{ step.text }}</p>
                </li>
            </ol>
        </section>

        <TestimonialsSection />

        <section id="home-cta" class="section final-cta">
            <h2 class="final-cta-title">¿Empezamos?</h2>
            <p class="final-cta-text">
                Cuéntanos tu idea y te respondemos en menos de 24 horas hábiles.
                Si prefieres, escríbenos directo por WhatsApp.
            </p>

            <ul class="final-cta-points">
                <li>Software y fabricación con un mismo equipo</li>
                <li>Convertimos lo difícil en algo que funciona</li>
                <li>Términos de trabajo flexibles, a tu medida</li>
            </ul>

            <div class="cta-group">
                <router-link to="/contact" class="button">Solicita tu cotización</router-link>
                <router-link to="/print3d" class="button">Cotiza tu impresión 3D</router-link>
            </div>
        </section>
    </div>
</template>

<script>
import HeroSection from './HeroSection.vue';
import CatalogTeaser from './Home/CatalogTeaser.vue';
import AreasSection from './Home/AreasSection.vue';
import TestimonialsSection from './Home/TestimonialsSection.vue';

export default{
    name: 'HomePage',
    components: { HeroSection, CatalogTeaser, AreasSection, TestimonialsSection },
    data() {
        return {
            steps: [
                {
                    title: 'Nos cuentas',
                    text: 'Describes tu necesidad o subes tu archivo. Sin formularios eternos: lo mínimo para entender el caso.',
                    icon: require('../assets/iconOne.svg'),
                    iconAlt: 'Cuéntanos tu necesidad',
                },
                {
                    title: 'Te proponemos',
                    text: 'Revisamos el caso y te enviamos alcance, tiempo y precio claros, en menos de 24 horas hábiles.',
                    icon: require('../assets/iconTwo.svg'),
                    iconAlt: 'Te enviamos la propuesta',
                },
                {
                    title: 'Lo hacemos realidad',
                    text: 'Desarrollamos o fabricamos, te mantenemos al tanto del avance y entregamos funcionando.',
                    icon: require('../assets/iconThree.svg'),
                    iconAlt: 'Entregamos la solución',
                },
            ],
        };
    },
}

</script>

<style scoped>
/* ---------- Cómo trabajamos ---------- */
.process-title {
    font-family: var(--font-subtitle);
    font-weight: 700;
    font-size: 40px;
    line-height: 1.1;
    color: var(--color-title);
    margin: 0 0 var(--space-sm) 0;
}

.process-intro {
    font-family: var(--font-body);
    font-size: 20px;
    line-height: 1.5;
    color: var(--color-text);
    max-width: 46rem;
    margin: 0 0 var(--space-lg) 0;
}

.process-steps {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--space-md);
}

.process-step {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--space-md);
    border-left: 3px solid var(--color-accent);
    background-color: var(--color-surface);
    border-radius: 0 12px 12px 0;
}

.process-step img {
    height: 48px;
    width: auto;
    margin-bottom: var(--space-sm);
}

.process-number {
    font-family: var(--font-body);
    font-size: 15px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-brand);
    margin-bottom: 0.25rem;
}

.process-step-title {
    font-family: var(--font-subtitle);
    font-weight: 700;
    font-size: 22px;
    line-height: 1.2;
    color: var(--color-title);
    margin: 0 0 var(--space-xs) 0;
}

.process-step-text {
    font-family: var(--font-body);
    font-size: 17px;
    line-height: 1.45;
    color: var(--color-text);
    margin: 0;
}

/* ---------- CTA final ---------- */
.final-cta {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: var(--space-xl) var(--space-md);
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 20px;
}

.final-cta-title {
    font-family: var(--font-display);
    font-weight: 700;
    font-size: 48px;
    line-height: 1.05;
    letter-spacing: -1.5px;
    color: var(--color-title);
    margin: 0 0 var(--space-sm) 0;
}

.final-cta-text {
    font-family: var(--font-body);
    font-size: 20px;
    line-height: 1.5;
    color: var(--color-text);
    max-width: 40rem;
    margin: 0 0 var(--space-md) 0;
}

.final-cta-points {
    list-style: none;
    margin: 0 0 var(--space-md) 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--space-sm) var(--space-md);
}

.final-cta-points li {
    font-family: var(--font-body);
    font-size: 17px;
    color: var(--color-text);
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.final-cta-points li::before {
    content: '✔';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--color-accent);
    color: var(--color-white);
    font-size: 11px;
    flex-shrink: 0;
}

.cta-group {
    display: flex;
    flex-direction: row;
    gap: var(--space-sm);
    flex-wrap: wrap;
    justify-content: center;
}

@media (max-width: 1024px) {
    .process-steps { grid-template-columns: 1fr; }
}

@media (max-width: 800px) {
    .process-title { font-size: 1.75rem; text-align: center; margin-bottom: var(--space-md); }
    .process-intro { text-align: center; }
    .final-cta-title { font-size: 2rem; letter-spacing: 0; }
    .final-cta-points { flex-direction: column; align-items: flex-start; text-align: left; }
}
</style>
